import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const year = new Date().getFullYear();
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__intro">
        <div className="site-footer__story">
          <h2>Story</h2>
          <p>
            {siteConfig.brandName} makes organic-cotton denim and everyday
            clothing designed to develop character through use.
          </p>
        </div>
        <div className="site-footer__signup">
          <h2>Customer care</h2>
          <p>For a product, order, parcel, return, or privacy question:</p>
          <address className="site-footer__contact">
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
            <span>{siteConfig.contact.address}</span>
          </address>
        </div>
      </div>

      <div className="site-footer__links">
        <section>
          <h3>Order journey</h3>
          <Link to="/terms-of-sale" onClick={toTop}>
            Terms of sale
          </Link>
          <Link to="/orders-payment" onClick={toTop}>
            Payment &amp; order review
          </Link>
          <Link to="/cancellations" onClick={toTop}>
            Cancellations
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Shipping &amp; customs
          </Link>
          <Link to="/delivery-issues" onClick={toTop}>
            Parcel problems
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns &amp; refunds
          </Link>
        </section>
        <section>
          <h3>Products</h3>
          <Link to="/product-information" onClick={toTop}>
            Fit, fibre &amp; colour
          </Link>
          <Link to="/product-care" onClick={toTop}>
            Wear &amp; care
          </Link>
          <Link to="/limited-stock" onClick={toTop}>
            Limited stock
          </Link>
          <Link to="/offer-codes" onClick={toTop}>
            Offer codes
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
        </section>
        <section>
          <h3>Privacy &amp; access</h3>
          <Link to="/privacy" onClick={toTop}>
            Privacy journey
          </Link>
          <Link to="/privacy-choices" onClick={toTop}>
            Data rights
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Device storage
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            Accessibility
          </Link>
          <Link to="/terms-of-use" onClick={toTop}>
            Website rules
          </Link>
          <Link to="/intellectual-property" onClick={toTop}>
            Content rights
          </Link>
        </section>
        <section>
          <h3>Support</h3>
          <Link to="/policies" onClick={toTop}>
            All policies
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact us
          </Link>
          <Link to="/contact-policy" onClick={toTop}>
            Contact information
          </Link>
          <Link to="/complaints" onClick={toTop}>
            Complaints &amp; updates
          </Link>
          <Link to="/about" onClick={toTop}>
            About {siteConfig.brandName}
          </Link>
        </section>
      </div>

      <div className="site-footer__bottom">
        <Link
          to="/"
          onClick={toTop}
          className="site-footer__wordmark"
          aria-label={`${siteConfig.brandName} home`}
        >
          {siteConfig.logoText}
        </Link>
        <div className="site-footer__legal">
          <span>
            © {year} {siteConfig.brandName}
          </span>
          <Link to="/terms-of-sale" onClick={toTop}>
            Terms of sale
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Storage
          </Link>
          <span>{siteConfig.operatingRegion}</span>
          <span>
            {siteConfig.locale} / {siteConfig.currency}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
